<div class="chart-container">
  <canvas *ngFor="let chart of charts; let i = index" id="lineCharts{{ i }}" #lineCharts trackBy:trackById>{{ chart.chart }}</canvas>
</div>
